import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class FormEndpoint extends BaseEndpoint {}
